<template>
  <div>
    <h4 class="text-h4">Pathologist registration form</h4>
    <p class="body-1 mt-1">* = Field required.</p>
    <v-row class="mt-2">
      <v-col cols="6">
        <v-radio-group v-model="model.title" row>
          <v-radio label="Dr." value="Dr" />
          <v-radio label="Dra." value="Dra" />
        </v-radio-group>
      </v-col>
      <v-col cols="6">
        <v-text-field label="First name(s)" v-model="model.firstName" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field label="Apellido 1*" v-model="model.lastName" />
      </v-col>
      <v-col cols="6">
        <v-text-field label="Apellido 2" v-model="model.lastName2" />
      </v-col>
    </v-row>
    <EmailAndPassword v-model="model" />
    <v-row>
      <v-col cols="12">
        <v-btn primary @click="onClickRegister" :loading="loading"
          >Register</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import EmailAndPassword from "@/components/registration/EmailAndPassword";
import { register } from "@/api/craiyon";

export default {
  components: { EmailAndPassword },
  data() {
    return {
      loading: false,
      model: {
        title: null,
        firstName: null,
        lastName: null,
        lastName2: null,
        email: null,
        emailRepeat: null
      }
    };
  },
  methods: {
    async onClickRegister() {
      // TODO validation
      console.log(this.model);
      this.loading = true;
      this.model = {
        ...this.model,
        type: "pathologist",
        name: `${this.model.title} ${this.model.firstName} ${this.model.lastName}`
      };
      if (this.model.lastName2) this.model.name += ` ${this.model.lastName2}`;
      const response = await register(this.model);
      // FIXME leave this out until we hav an SMTP server connected to keycloak and sending emails actually works
      // if (response.statusCode > 299) {
      //   // TODO show  some message
      //   return;
      // }

      this.$emit("registered");
      this.loading = false;
    }
  }
};
</script>

<style scoped></style>
